import { render, staticRenderFns } from "./ProAppIntelligenceStarterSuggestions.vue?vue&type=template&id=29ec244f&scoped=true&"
import script from "./ProAppIntelligenceStarterSuggestions.vue?vue&type=script&lang=js&"
export * from "./ProAppIntelligenceStarterSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./ProAppIntelligenceStarterSuggestions.vue?vue&type=style&index=0&id=29ec244f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ec244f",
  null
  
)

export default component.exports